export const getListItemName = (
  id: number,
  list: { id: number; name: string }[]
) => {
  const item = list.find(item => item.id === id);
  return item ? item.name : "";
};
